import { AgendaServico, ConsultaOS, GetBolsao, GetNoShow, GetOrcamentoComplementar, IAgendaVeiculo, OrcamentoComplementarQtdTotal, OsAberta, TypeServiceResponse, IKanbanStatus, AutomaticSchedulingReport } from "@/models/AgendaModel";
import ApiService from "./ApiService";

export const getBaseAgendamento = async (codConcessionaria, diferencaDia = 0 , agendamentoCache = 0) => {
    const { data } = await ApiService.getIntegracao(`agendamento/${codConcessionaria}/${diferencaDia}/${agendamentoCache}`);
    return data;
};

export const getBaseAgendamentoEntrega = async (codConcessionaria, diferencaDia = 0) => {
    const { data } = await ApiService.getIntegracao(`agendamentoEntrega/${codConcessionaria}/${diferencaDia}`);
    return data;
};

export const getServicosAgendados = async (codConcessionaria, date) :  Promise<AgendaServico[]> => {
    const { data } = await ApiService.get(`agendamentoServicos/${codConcessionaria}/${date}`);
    return data;
};

export const getServicosAgendadosFiltrados = async (codConcessionaria, postData) => {
    const { data } = await ApiService.post(`agendamentoServicosFiltrado/${codConcessionaria}`, postData);
    return data;
};

export const getMecanicos = async (codConcessionaria) => {
    const { data } = await ApiService.get(`mecanicosquadro/${codConcessionaria}`);
    return data;
};

export const getHorariosOcupadosMecanicos = async (codConcessionaria, date) => {
    const { data } = await ApiService.get(`horariosOcupadosTecnicos/${codConcessionaria}/${date}`);
    return data;
};

export const addAgendamento = async (postData) => {
    const { data } = await ApiService.post(`agendamento`, postData);
    return data;
};

export const addTempoAdicionalAgendamento = async (postData) => {
    const { data } = await ApiService.post(`agendamentoTempoAdicional`, postData);
    return data;
};

export const addAgendamentoMecanico = async (postData) => {
    const { data } = await ApiService.post(`agendamentoMecanico`, postData);
    return data;
};

export const editAgendamento = async (idservico, postData) => {
    const { data } = await ApiService.put(`agendamento/${idservico}`, postData);
    return data;
};

export const editAllAgendamento = async (postData) => {
    const { data } = await ApiService.put(`editallagendamento`, postData);
    return data;
};

export const deletarAgendamento = async (postData) => {
    const { data } = await ApiService.post(`deleteAgendamento`, postData);
    return data;
};

export const iniciaServicoAgendado = async (agendamentoID) => {
    const { data } = await ApiService.post(`iniciaServicoAgendado/${agendamentoID}`, {});
    return data;
};
 
export const atualizaPercentualRealizado = async (agendamentoID, percentualRealizado) => {
    const { data } = await ApiService.post(`atualizaPercentualRealizado/${agendamentoID}/${percentualRealizado}`, {});
    return data;
};

export const paralisaServico = async (agendamentoID) => {
    const { data } = await ApiService.post(`paralisaServico/${agendamentoID}`, {});
    return data;
};

export const finalizaServicoAgendado = async (agendamentoID) => {
    const { data } = await ApiService.post(`finalizaServicoAgendado/${agendamentoID}`, {});
    return data;
};

export const cancelaServicoAgendado = async (agendamentoID) => {
    const { data } = await ApiService.post(`cancelaInicioServicoAgendado/${agendamentoID}`, {});
    return data;
};

export const entregaRealizadaServicoAgendado = async (agendamentoID) => {
    const { data } = await ApiService.post(`entregaRealizadaServicoAgendado/${agendamentoID}`, {});
    return data;
};

export const controleQualidadeRealizado = async (agendamentoID) => {
    const { data } = await ApiService.post(`qualidadeRealizadaServicoAgendado/${agendamentoID}`, {});
    return data;
};

export const cancelarControleQualidade = async (agendamentoID) => {
    const { data } = await ApiService.post(`cancelaQualidadeServicoAgendado/${agendamentoID}`, {});
    return data;
};

export const cancelaEntregaServicoAgendado = async (agendamentoID) => {
    const { data } = await ApiService.post(`cancelaEntregaServicoAgendado/${agendamentoID}`, {});
    return data;
};

export const getConsultores = async (codConcessionaria: number) => {
    const { data } = await ApiService.get(`/agendaconsultores/${codConcessionaria}`);
    return data;
};

export const consultaOsAgenda = async (payload) : Promise<ConsultaOS> => {
    const { data } = await ApiService.post(`/consultaOsAgenda`, payload);
    return data;
};

export const getServicosParalizados = async (codConcessionaria: number) : Promise<AgendaServico> =>{
    const { data } = await ApiService.get(`/servicosParalizado/${codConcessionaria}`);
    return data;
};

export const programarServicoParalizado = async (payload) => {
    const { data } = await ApiService.post(`/programadoServicoParalizado/${payload.codServico}`, payload);
    return data;
};

export const removerServicoParalizado = async (codServico: string) : Promise<string> =>{
    const { data } = await ApiService.get(`/removerServicoParalizado/${codServico}`);
    return data;
};

export const getOsAberta = async (codConcessionaria: number, day: string | number = 0) : Promise<OsAberta[]> =>{
    const { data } = await ApiService.getIntegracao(`/agenda/os-aberta/${codConcessionaria}/${day}`);
    return data;
};

export const orcamentoComplementar = async (codConcessionaria: number) : Promise<GetOrcamentoComplementar> =>{
    const { data } = await ApiService.get(`/orcamento-complementar/${codConcessionaria}`);
    return data;
};

export const orcamentoComplementarTotal = async (codConcessionaria: number) : Promise<OrcamentoComplementarQtdTotal> =>{
    const { data } = await ApiService.get(`/orcamento-complementar/total/${codConcessionaria}`);
    return data;
};

export const noShow = async (codConcessionaria: number) : Promise<GetNoShow[]> =>{
    const { data } = await ApiService.get(`/agendaVirtual/noShow/${codConcessionaria}`);
    return data;
};

export const bolsao = async (codConcessionaria: number, nameBolsao : string) : Promise<GetBolsao[]> =>{
    const { data } = await ApiService.get(`/agendaVirtual/bolsao/${codConcessionaria}/${nameBolsao}`);
    return data;
};

export const typeService = async (scheduleModel : string) : Promise<TypeServiceResponse[]> =>{
    const { data } = await ApiService.get(`/tipoServico/${scheduleModel}`);
    return data;
};

export const getDataByKeyRedis = async (keyRedis : string) => {
    const { data } = await ApiService.get(`/getDataByKeyRedis/${keyRedis}`);
    return data;
};

export const getVeiculosAgenda = async (codConcessionaria: number) : Promise<IAgendaVeiculo[]> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}`);
    return data;
};

export const moveAgendaVeiculo = async (codConcessionaria: number, id: number, payload) : Promise<IAgendaVeiculo> => {
    const { data } = await ApiService.post(`/agenda-veiculos/${codConcessionaria}/${id}/move`, payload);
    return data;
};

export const getStatusKanban = async (codConcessionaria: number) : Promise<IKanbanStatus[]> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/status`);
    return data;
};

export const getStatusKanbanParalisado = async (codConcessionaria: number) : Promise<IKanbanStatus[]> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/status-paralisado`);
    return data;
};

export const getAgendaVeiculoByID = async (codConcessionaria: number, id: number) : Promise<IAgendaVeiculo> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/${id}`);
    return data;
};

export const getAgendaComentarios = async (codConcessionaria: number, id: number): Promise<any[]> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/${id}/comentarios`);
    return data;
};

export const getChecklistsAtivos = async (codConcessionaria: number, id: number): Promise<any[]> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/${id}/checklists-ativos`);
    return data;
};

export const getPassantesWithoutAgendaVeiculo = async (codConcessionaria: number): Promise<any[]> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/passantes`);
    return data;
};

export const fetchAutomaticScheduling = async (
    codConcessionaria: number,
    date?: string
): Promise<AutomaticSchedulingReport[]> => {
    let url = `/agendaVirtual/programacao-automatica/${codConcessionaria}`;

    // adiciona o date se existir
    if (date) {
        url += `?date=${encodeURIComponent(date)}`;
    }

    const { data } = await ApiService.get(url);
    return data;
};

export const saveAgendaComentario = async (
    codConcessionaria: number,
    id: number,
    payload: {
        comentario: string,
        tipo?: 'informacao' | 'andamento' | 'problema' | 'outro',
        agenda_servico_codServico?: number
    }
): Promise<any> => {
    const { data } = await ApiService.post(`/agenda-veiculos/${codConcessionaria}/${id}/comentarios`, payload as any);
    return data;
};

export const getAgendaAnexos = async (codConcessionaria: number, checklist: number, codChecklist: number): Promise<any[]> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/${checklist}/${codChecklist}/anexos`);
    return data;
};

export const saveAgendaAnexo = async (codConcessionaria: number, checklist: number, codChecklist: number, payload): Promise<any> => {
    const data = await ApiService.postBlob(`/agenda-veiculos/${codConcessionaria}/${checklist}/${codChecklist}/anexos`, payload as any) as Blob;
    return data;
};

export const deleteAgendaAnexo = async (codConcessionaria: number, checklist: number, codChecklist: number, id: number): Promise<any> => {
    const { data } = await ApiService.delete(`/agenda-veiculos/${codConcessionaria}/${checklist}/${codChecklist}/anexos/${id}`);
    return data;
};

export const getAgendaReport = async (codConcessionaria: number) => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/report`);
    return data;
};

export const getAgendaLogs = async (codConcessionaria: number, id: number): Promise<any[]> => {
    const { data } = await ApiService.get(`/agenda-veiculos/${codConcessionaria}/${id}/events`);
    return data;
};

export const putHorarioEntregaOuRecepcao = async (codConcessionaria: number, id: number, request): Promise<any> => {
    const { data } = await ApiService.put(`/agenda-veiculos/${codConcessionaria}/${id}`, request);
    return data;
};